<template>
  <page-layout
    :breadcrumbs="[
      {
        text: textoTipoSolicitudes.toUpperCase(),
        disabled: true
      }
    ]">
    <div v-if="cambiandoColumnas" style="position: relative;" class="pt-2 pl-2 pr-2 pb-0">
      <draggable xs12 v-model="headersTablaOrden" id="headersTablaOrden">
        <v-chip v-for="(header, index) in headersTabla" :key="'columna' + header.codigoColumna"
          class="mt-0 mb-1 mx-1 elevation-0" outlined color="primary"
          label small style="cursor: pointer; height: 40px">
          <v-icon left small color="primary">mdi-cursor-move</v-icon>
            <span style="font-weight: bold" :class="header.ocultada ? 'grey--text' : 'primary--text'">{{header.text !== '' ? header.text : 'IMAGEN ESTADO'}}</span>
            <v-icon  v-if="header.ocultable" right small color="primary"
              @click="headersTabla[index].ocultada = !header.ocultada; heCambiadoColumnas = true">
                {{header.ocultada ? 'mdi-eye-off' : 'mdi-eye'}}
            </v-icon>
        </v-chip>
      </draggable>
      <v-divider class="primary" style="border-width: 2px 0 0 0;margin-top:1px;"/>
      <v-row class="pa-2" justify="center" style="position: absolute;bottom:-60px;margin:auto;left:0;right:0;">
        {{ $t('activarDesactivarVisibilidadColumnas') }}
      </v-row>
    </div>
    <v-layout v-if="!cambiandoColumnas">
      <v-flex lg12>
        <v-layout justify-center>
          <v-data-table ref="tabla" :headers="headersFiltrados" :items="getIncidencesList" v-model="selectedItems" id="selectedItems"
            item-key="id" class="text-xs-center" :loading="waitingForLoad"
            :footer-props="{
              'items-per-page-text': $t('filasPorPagina'),
              'show-current-page': true
            }"
            :show-current-page="true"
            loading-text="this.$t('cargandoDatos')"
            @update:items-per-page="itemPerPage"
            @update:page="getPage($event)"
            :hide-default-headers="cambiandoColumnas"
          >
            <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ headers }">
              <v-tooltip left :key="h.id" v-if="h.tooltip">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{h.text}}</span>
                </template>
                <v-list class="lista-tooltip">
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-hammer</v-icon>
                    &nbsp;Incidencia
                  </v-list-item>
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-phone</v-icon>
                    &nbsp;Comercial
                  </v-list-item>
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-file-document-outline</v-icon>
                    &nbsp;Administrativa
                  </v-list-item>
                  <v-list-item>
                    <v-icon color="primary lighten-1">mdi-help-circle-outline</v-icon>
                    &nbsp;Otras
                  </v-list-item>
                </v-list>
              </v-tooltip>
              <v-tooltip bottom :key="h.id" v-if="!h.tooltip">
                <template v-slot:activator="{ off }">
                  <span v-on="off">{{h.text}}</span>
                </template>
              </v-tooltip>
            </template>
            <template
              v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items"
                  :key="item.id"
                  @dblclick="countSelected && !oneClick() ? dobleClick($event, item.id) : null"
                  @mouseover="countSelected ? mouseOver(item) : null"
                  @mouseleave="countSelected ? mouseLeave() : null"
                  :style="{
                    opacity: cambiandoColumnas ? 0 : 1,
                    'pointer-events': cambiandoColumnas ? 'none' : 'auto',
                    'background-color': selectedItems.some(x => x.id === item.id) ? 'lightgray' : ''
                  }"
                >
                  <template v-for="(header, index) in headersFiltrados">
                    <td :style="getStyle(header.value)"
                      seleccionable="true"
                      :class="header.classTd"
                      class="text-xs-center recortarStyle"
                      :key="'td-' + item.id + '-' + header.value"
                      @mouseover.native="countSelected ? mouseOver(item) : null"
                      @mouseleave.native="countSelected ? mouseLeave() : null"
                    >
                      <template v-if="selectedItems.length === 0 && itemEncima === item.id && index === headersFiltrados.length - 1">
                        <v-layout row justify-center>
                          <v-flex class="clickable text-xs-center" @click="goDetail(item.id)">
                            <v-icon class="icono-hover" color="#2c61a0" small title="Detalle">remove_red_eye</v-icon>
                          </v-flex>
                          <v-flex v-if="((item.statusCode == 30 && getConfiguracion.desdeTerminadoWeb) || (item.statusCode == 41 && getConfiguracion.configVistoBuenoClienteWeb)) && getConfiguracion.clientesCerrarWeb" class="clickable text-xs-center" @click="setNuevoEstado(item, 50)">
                            <v-icon class="icono-hover" color="#2c61a0" small title="Conforme">check</v-icon>
                          </v-flex>
                          <v-flex v-if="((item.statusCode == 30 && getConfiguracion.desdeTerminadoWeb) || (item.statusCode == 41 && getConfiguracion.configVistoBuenoClienteWeb)) && getConfiguracion.clientesRechazarWeb" class="clickable text-xs-center" @click="setNuevoEstado(item, 90)" >
                            <v-icon class="icono-hover" color="#2c61a0" small title="Rechazar">close</v-icon>
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-else-if="header.value === 'img'">
                        <v-icon :color="calculaColorEstado(item)">{{ imagenes[item.statusCode].icono }}</v-icon>
                      </template>
                      <template v-else-if="header.value === 'id'" >{{ item.referencia }}</template>
                      <template v-else-if="header.value === 'state'">{{ item.state }}</template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '1'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-hammer</v-icon>
                          </template>
                          <span>Incidencia</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '2'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-file-document-outline</v-icon>
                          </template>
                          <span>Administrativa</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '3'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-phone</v-icon>
                          </template>
                          <span>Comercial</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'idSolicitud' && item.idSolicitud === '4'">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary lighten-1" v-on="on" style="cursor: pointer;">mdi-help-circle-outline</v-icon>
                          </template>
                          <span>Otras</span>
                        </v-tooltip>
                      </template>
                      <template v-else-if="header.value === 'nombrePromocion'">{{ item.nombrePromocion }}</template>
                      <template v-else-if="header.value === 'locationJS'"><span class="claseLocation" v-html="item.location"/></template>
                      <template v-else-if="header.value === 'room'">{{ item.room }}</template>
                      <template v-else-if="header.value === 'description'">{{ item.description }}</template>
                      <template v-else-if="header.value === 'profession'">{{ item.profession }}</template>
                      <template v-else-if="header.value === 'openDate'">{{ item.openDate }}</template>
                      <template v-else-if="header.value === 'notificationDate'">{{ item.notificationDate }}</template>
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-layout>

        <Filters
          ref="filters"
          :codigoTipoSolicitudes="codigoTipoSolicitudes"
          :storeFilters="storeFilters"
          @codigoTipoSolicitudesInput="codigoTipoSolicitudes = $event"
          @valoresFiltros="loadConFiltros($event)"
        />
      </v-flex>
    </v-layout>
  </page-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Filters from './filtrosRolCliente'

import draggable from 'vuedraggable'

export default {
  components: {
    Filters,
    draggable
  },
  beforeCreate () {
    document.documentElement.classList.add('showScrollbar2')
  },
  data () {
    return {
      codigoSolicitudEnRuta: '',
      showTooltip: false,
      codigoTipoSolicitudes: null,
      waitingForLoad: true,
      selectedItems: [],
      disableDetail: false,
      disableUpdate: false,
      dialog: false,
      singleItem: [],
      estadoOrigen: "0",
      dialogUpdate: false,
      itemId: [], // lo hacemos array para poder borrar masivamente
      loader: null,
      datosNuevoEstado: null,
      lastItemPerPage: null,
      filtros: null,
      fichasPDF: [
        { title : this.$t('fichaIncidencia'), tipo: 'I' },
        { title : this.$t('fichaVisita'), tipo: 'V' },
        { title : this.$t('incidenciasCerradas'), tipo: 'C' }
      ],
      imagenes: {
        10 : {icono: 'build', color: '#E7D123', colorPasado: '#D40500'},
        20 : {icono: 'build', color: '#E7D123', colorPasado: '#D40500'},
        30 : {icono: 'build', color: '#4BAF29'},
        40 : {icono: 'build', color: '#4BAF29'},
        41 : {icono: 'build', color: '#4BAF29'},
        50 : {icono: 'flag',  color: '#4BAF29'},
        90 : {icono: 'clear', color: '#D40500'}
      },
      itemEncima: 0,
      waitingForLoadTablas: false,
      cambiandoColumnas: false,
      heCambiadoColumnas: false,
      headersTabla: [],
      headers: [
        { text: '', sortable: false, value: 'img', align: 'center', tooltip: false },
        { text: this.$t('m_id'), sortable: true, value: 'id', align: 'rigth', tooltip: false },
        { text: this.$t('m_estado'), value: 'state', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_tipoSolicitud'), value: 'idSolicitud', sortable: true, align: 'center', tooltip: true },
        { text: this.$t('m_promocion'), value: 'nombrePromocion', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_ubicacion'), value: 'locationJS', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_localizacion'), value: 'room', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_descripcion'), value: 'description', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_oficio'), value: 'profession', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_entrada'), value: 'openDate', sortable: true, align: 'center', tooltip: false },
        { text: this.$t('m_aviso'), value: 'notificationDate', sortable: true, align: 'center', tooltip: false },
      ],
      clickCount: 0,
      clickTimer: null
    }
  },
  created () {
    this.loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel,
    })
    this.inicializarTabla()
    this.validarTipoSolicitudes()
    // this.load()
    this.loadConFiltros(this.filtros)
    this.codigoSolicitudEnRuta = this.$route.query.codigoTipoSolicitudes
    if (this.codigoSolicitudEnRuta > 0) {
      this.$store.commit('incidencias/setNavCodTipoSolicitud', this.codigoSolicitudEnRuta)
    } else {
      this.$store.commit('incidencias/setNavCodTipoSolicitud', '0')
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getIncidencias: 'incidencias/getIncidencias',
      delIncidencias: 'incidencias/delIncidencias',
      updateIncidenceStatus: 'incidencias/updateIncidenceStatus'
    }),
    selectAll (event) {
      this.$refs.tabla.toggleSelectAll(event)
      if (!event) {
        this.selectedItems = []
      }
    },
    getPage (e) {
      this.$store.commit('incidencias/setLastPageVisited', e)
    },
    oneClick (item) {
      this.clickCount++
      if (this.clickCount === 1 && item != null) {
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0
          if (this.selectedItems.length !== 0 && this.selectedItems.some(x => x.id === item.id)) {
            let index = this.selectedItems.indexOf(item)
            this.selectedItems.splice(index, 1)
          } else {
            this.selectedItems.push(item)
          }
        }, 200)
      } else if (this.clickCount === 2) {
        clearTimeout(this.clickTimer)
        this.clickCount = 0
        return false
      }
    },
    async configurarTabla () {
      if (this.cambiandoColumnas && this.heCambiadoColumnas) {
        this.waitingForLoadTablas = true
        localStorage.setItem('headers', JSON.stringify(this.headersTabla))
        this.waitingForLoadTablas = false
        this.inicializarTabla()
      } else {
        this.heCambiadoColumnas = false
      }
      this.cambiandoColumnas = !this.cambiandoColumnas
    },
    inicializarTabla () {
      this.headersTabla = [
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'img', ocultable: true, ocultada: false, orden: 0},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'id', ocultable: true, ocultada: false, orden: 1},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'state', ocultable: true, ocultada: false, orden: 2},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'idSolicitud', ocultable: true, ocultada: false, orden: 3},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'nombrePromocion', ocultable: true, ocultada: false, orden: 4},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'locationJS', ocultable: true, ocultada: false, orden: 5},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'room', ocultable: true, ocultada: false, orden: 6},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'description', ocultable: true, ocultada: false, orden: 7},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'profession', ocultable: true, ocultada: false, orden: 8},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'openDate', ocultable: true, ocultada: false, orden: 9},
        {actorId: this.$store.state.login.credentials.id_actor, codigoColumna: 'notificationDate', ocultable: true, ocultada: false, orden: 10}
      ].map(x => {
        let retorno = {...x}
        retorno.text = this.headers.find(y => x.codigoColumna === y.value).text
        return retorno
      })
    },
    validarTipoSolicitudes () {
      const tipo = this.$route.query.codigoTipoSolicitudes
      if (tipo !== undefined && tipo !== null) {
        if (this.tiposSolicitud.find(x => x.codigoTipoSolicitud.toString() === tipo.toString()) === undefined) {
          this.addAlert({ texto: this.$t('sinPermisosParaAcceder'), color: 'error' })
          this.$router.push('home')
          this.loader.hide()
        }
        this.codigoTipoSolicitudes = tipo
      } else {
        this.codigoTipoSolicitudes = null
      }
    },
    async setNuevoEstado (incidencia, codigoEstado) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        });

        // Estado
        let nuevoEstado = this.getEstados.find(x => x.code === codigoEstado.toString())

        let values = [{
          incidenceId: [incidencia.id],
          statusId: nuevoEstado.id,
          updateDate: new Date().toISOString().substr(0, 10),
          updateDescription: "Estado modificado por cliente",
          vb: "0"
        }];

        await this.updateIncidenceStatus(values)
        await this.loadConFiltros(this.filtros)
        this.addAlert({ texto: this.$t('incidencia_actualizada'), color: 'success' })
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    async load () {
      try {
        this.waitingForLoad = true
        this.selectedItems = []
        this.dialog = false
        await this.getIncidencias({
          codigoTipoSolicitud: this.codigoTipoSolicitudes
        })
        this.waitingForLoad = false
        this.loader.hide()
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    async loadConFiltros (valores) {
      try {
        this.filtros = valores
        this.waitingForLoad = true
        this.selectedItems = []
        this.dialog = false
        await this.getIncidencias(valores)
        this.waitingForLoad = false
        this.loader.hide()
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
          this.loader.hide()
        }
      }
    },
    cancelDialog () {
      this.singleItem = []
      this.selectedItems = []
      this.dialog = false
    },
    goDetail (itemId) {
      this.$router.push({ path: `/solicitudes/${itemId}` })
    },
    modifyState (item) {
      this.singleItem = []
      this.singleItem.push(item.id)
      this.estadoOrigen = item.statusCode
      this.dialog = true
    },
    modifyStateArray () {
      // comprobamos que todas las incidencias tengan el mismo estado
      var estados = this.selectedItems.map(function(item){ return item.stateId });
      var estadosDiferentes = [...new Set(estados)].length === 1 ? true: false;
      if(!estadosDiferentes) {
        this.addAlert({texto: this.$t('incidencias_mismo_estado'), color: 'error'})
        return
        // tiene estados diferentes, sacamos error
      }
      this.estadoOrigen = this.selectedItems[0].statusCode
      this.singleItem = []
      this.dialog = true
    },
    goToSingleIncidence (name, idIncidencia) {
      this.$router.push({ name: name, params: {idIncidencia: idIncidencia} })
    },
    mapearListaIncidencias (incidencias) {
      return incidencias.map(function (a) {
        return {
          direccion: a.location,
          promocion: a.propertyDevelopment || null,
          informacionAdicional: a.additionalInformation,
          cliente: a.cliente,
          fechaCierre: a.closeDate,
          idSolicitud: a.idSolicitud,
          costeReal: a.costeReal,
          descripcion: a.description,
          emailCliente: a.emailCliente,
          fechaEstado: a.fechaEstado,
          id: a.id,
          numeroIncidencia: a.incidenceNumber,
          inmuebleEspecial: a.inmuEspe,
          inmueble: a.inmueble,
          visita: a.listNumber,
          movilCliente: a.movilCliente,
          nombreCliente: a.nombreCliente,
          nombrePromocion: a.nombrePromocion,
          fechaNotificacion: a.notificationDate,
          fechaApertura: a.openDate,
          origen: a.origen,
          oficio: a.profession,
          proveedor: a.proveedor,
          ubicacion: a.room,
          estado: a.state,
          idEstado: a.stateId,
          codigoEstado: a.statusCode,
          telefonoCliente: a.telefonoCliente,
          vistoBueno: a.vistoBueno,
          tipoSolicitud: a.tipoSolicitud,
          predefinida: a.incidenciaPredefinida
        }
      })
    },
    calculaColorEstado (item) {
      if((item.statusCode === '10' || item.statusCode === '20') && item.imageState.indexOf('red') >= 0) {
        return this.imagenes[item.statusCode].colorPasado
      }
      return this.imagenes[item.statusCode].color
    },
    itemPerPage (val) {
      if (this.lastItemPerPage == null || val !== this.lastItemPerPage) {
        this.selectedItems =  []
        this.lastItemPerPage = val
      }
    },
    dobleClick (evento, id) {
      if(evento.target.getAttribute("seleccionable") === 'true') {
        this.goDetail(id)
      }
    },
    mouseOver (item) {
      this.itemEncima = item.id
    },
    mouseLeave () {
      this.itemEncima = 0
    },
    getStyle (value) {
      switch (value) {
        case 'img':
          return 'max-width: 80px;'
        case 'id':
          return 'max-width: 80px;'
        case 'state':
          return 'max-width: 150px;'
        case 'idSolicitud':
          return 'max-width: 150px;'
        case 'nombrePromocion':
          return 'max-width: 150px;'
        case 'locationJS':
          return 'max-width: 150px;'
        case 'room':
          return 'max-width: 150px;'
        case 'description':
          return 'max-width: 120px;'
        case 'prefession':
          return 'max-width: 120px;'
        case 'openDate':
          return 'max-width: 120px;'
        case 'notificationDate':
          return 'max-width: 120px;'
      }
    }
  },
  computed: {
    ...mapGetters({
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      getConfiguracion: 'configuracion/getConfiguracion',
      getterFiltrosStore: 'incidencias/getFiltrosCliente'
    }),
    getEstados () {
      if (this.$store.state.incidencias.estados) {
        return this.$store.state.incidencias.estados
      }
      return []
    },
    headersTablaOrden: {
      get () {
        return this.headersTabla
      },
      set (value) {
        this.headersTabla = value.map((x, i) => {
          x.orden = i
          return x
        })
        this.heCambiadoColumnas = true
      }
    },
    countSelected () {
      return this.selectedItems.length === 0
    },
    storeFilters: {
      get () {
        return this.getterFiltrosStore
      },
      set (value) {
        this.$store.commit('setFiltrosCliente', value)
      }
    },
    lastPage () {
      return this.$store.state.incidencias.lastPage
    },
    headersFiltrados () {
      let headers = this.headers.map(h => {
        let retorno = {...h}
        retorno.class = []
        retorno.classTd = []
        retorno.orden = 999
        retorno.ocultable = false
        retorno.ocultada = false
        if (h.value) {
          let hTabla = this.headersTabla.find(x => x.codigoColumna === h.value)
          if (hTabla) {
            retorno.orden = hTabla.orden
            retorno.ocultable = hTabla.ocultable
            retorno.ocultada = hTabla.ocultada
            if (h.class) {
              retorno.class.push(...h)
            }
            if (hTabla.ocultable && hTabla.ocultada && !this.cambiandoColumnas) {
              retorno.class.push('d-none')
              retorno.classTd.push('d-none')
            }
          }
        }
        return retorno
      }).filter(x => x.ocultada === false).sort((a, b) => a.orden - b.orden)
      return headers
    },
    getIncidencesList () {
      return this.$store.state.incidencias.listaIncidencias
    },
    textoTipoSolicitudes () {
      if (this.codigoTipoSolicitudes === null) {
        return this.$t('incidencias')
      } else {
        const aux = this.tiposSolicitud.find(x => x.codigoTipoSolicitud.toString() === this.codigoTipoSolicitudes.toString())
        return aux !== undefined ? aux.descripcionTipoSolicitud : this.$t('incidencias')
      }
    }
  },
  watch: {
    getIncidencesList () {
      this.selectedItems = []
    }
  },
  destroyed () {
    document.documentElement.classList.remove('showScrollbar2')
  }
}

</script>

<style scoped>
  .no-margin {
    margin: 0px !important;
  }
  .itemSelected tr:hover:not(.v-datatable__expand-row) {
    background: #ddecff !important;
  }
  .v-btn--floating.v-btn--small {
    height: 35px;
    width: 35px;
    margin: 0 !important;
  }
  .v-data-table {
    max-width: 100%;
    min-width: 100%;
    border: 1px solid #d6d6d6;
  }
  .clickable {
    cursor: pointer;
    text-align: center;
  }
  .v-data-table-header-mobile__wrapper {
    width: 85px !important;
  }
  .clickable:hover > i {
    background: rgba(80, 200, 255, .2);
    border-radius: 50%;
    width: 25px;
    height: 25px;
  }
  .fade-enter-active, .fade-leave-active {
    text-align: center;
    visibility: visible;
    opacity: 1;
    transition: opacity 0.2s ease;
  }
  .fade-enter, .fade-leave-to {
    text-align: center;
    visibility: hidden;
    opacity: 0;
  }
  .lista-tooltip {
    background: transparent;
  }
  .v-tooltip__content {
    border: 2px solid #d6d6d6;
    background: rgba(250, 250, 250, .8) !important;
    color: black;
  }
  .recortarStyle {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .d-none {
    display: none !important;
  }
  .claseLocation {
    white-space: pre-wrap;
  }
</style>